import { render, staticRenderFns } from "./codeListCreateModalGeneric.vue?vue&type=template&id=595beb3d&"
import script from "./codeListCreateModalGeneric.vue?vue&type=script&lang=ts&"
export * from "./codeListCreateModalGeneric.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports